module.exports = __webpack_public_path__ + "img/introduceList3.f978d7e1.jpg";